import axios from '../helper/axios';
import {DEFAULT_SEMESTER_URL, FULL_SCHEDULE_URL, SCHEDULE_BY_DATE_URL} from '../constants/axios';

export const fetchDefaultSemester = () =>
    axios.get(DEFAULT_SEMESTER_URL).then((res) => res.data);

export const fetchFullSchedule = (semesterId) =>
    axios.get(`${FULL_SCHEDULE_URL}${semesterId}`).then((res) => res.data);

export const fetchScheduleByDate = (semesterId) =>
    axios.get(`${SCHEDULE_BY_DATE_URL}?semesterId=${semesterId}`).then((res) => res.data);
